import { useState } from 'react';

const TourSearchForm = () => {
  const [month, setMonth] = useState('');
  const [direction, setDirection] = useState('');
  const [tourType, setTourType] = useState('');
  const [isMonthOpen, setIsMonthOpen] = useState(false);
  const [isDirectionOpen, setIsDirectionOpen] = useState(false);
  const [isTourTypeOpen, setIsTourTypeOpen] = useState(false);
  const [showAllTags, setShowAllTags] = useState(false);

  const months = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
  ];

  const directions = ['По России', 'За границу'];
  const tourTypes = ['Велотуры', 'Восхождение', 'Пешие', 'Горнолыжные'];

  const mainTags = [
    'Треккинги налегке',
    'Походы',
    'Экскурсии',
    'Яхтинг',
    'Экспедиции',
    'Море',
    'В горы'
  ];

  const additionalTags = [
    'Велотуры',
    'Горнолыжные',
    'Восхождения',
    'Сплавы',
    'Джип-туры',
    'Конные туры',
    'Фототуры',
    'Семейные туры',
    'Туры выходного дня',
    'Активный отдых',
    'Культурные туры',
    'Гастрономические туры',
    'Эко-туры'
  ];

  const allTags = showAllTags ? [...mainTags, ...additionalTags] : mainTags;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    const formData = new FormData(e.currentTarget);
    const data = new URLSearchParams();
    
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d4opq71fcjnktac9qd9g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString()
      });

      if (response.ok) {
        alert('Запрос отправлен! Мы свяжемся с вами в ближайшее время.');
        setMonth('');
        setDirection('');
        setTourType('');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="bg-gradient-to-br from-gray-50 to-white py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-[1360px] mx-auto px-6">
          <form id="tour-search-form" data-readdy-form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
              <div className="relative">
                <label className="block font-open-sans text-sm font-medium text-gray-700 mb-2">
                  Месяц / сезон
                </label>
                <button
                  type="button"
                  onClick={() => {
                    setIsMonthOpen(!isMonthOpen);
                    setIsDirectionOpen(false);
                    setIsTourTypeOpen(false);
                  }}
                  className="w-full h-[52px] px-4 text-left bg-gray-50 border border-gray-200 rounded-lg font-open-sans text-sm text-gray-700 hover:border-[#1E88E5] transition-colors cursor-pointer flex items-center justify-between"
                >
                  <span>{month || 'Выберите месяц'}</span>
                  <i className={`ri-arrow-down-s-line text-lg transition-transform ${isMonthOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isMonthOpen && (
                  <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-20 max-h-60 overflow-y-auto">
                    {months.map((m) => (
                      <button
                        key={m}
                        type="button"
                        onClick={() => {
                          setMonth(m);
                          setIsMonthOpen(false);
                        }}
                        className="w-full px-4 py-2 text-left font-open-sans text-sm text-gray-700 hover:bg-[#1E88E5]/10 hover:text-[#1E88E5] transition-colors cursor-pointer"
                      >
                        {m}
                      </button>
                    ))}
                  </div>
                )}
                <input type="hidden" name="month" value={month} />
              </div>

              <div className="relative">
                <label className="block font-open-sans text-sm font-medium text-gray-700 mb-2">
                  Направление
                </label>
                <button
                  type="button"
                  onClick={() => {
                    setIsDirectionOpen(!isDirectionOpen);
                    setIsMonthOpen(false);
                    setIsTourTypeOpen(false);
                  }}
                  className="w-full h-[52px] px-4 text-left bg-gray-50 border border-gray-200 rounded-lg font-open-sans text-sm text-gray-700 hover:border-[#1E88E5] transition-colors cursor-pointer flex items-center justify-between"
                >
                  <span>{direction || 'Выберите направление'}</span>
                  <i className={`ri-arrow-down-s-line text-lg transition-transform ${isDirectionOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isDirectionOpen && (
                  <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-20">
                    {directions.map((d) => (
                      <button
                        key={d}
                        type="button"
                        onClick={() => {
                          setDirection(d);
                          setIsDirectionOpen(false);
                        }}
                        className="w-full px-4 py-2 text-left font-open-sans text-sm text-gray-700 hover:bg-[#1E88E5]/10 hover:text-[#1E88E5] transition-colors cursor-pointer"
                      >
                        {d}
                      </button>
                    ))}
                  </div>
                )}
                <input type="hidden" name="direction" value={direction} />
              </div>

              <div className="relative">
                <label className="block font-open-sans text-sm font-medium text-gray-700 mb-2">
                  По типам
                </label>
                <button
                  type="button"
                  onClick={() => {
                    setIsTourTypeOpen(!isTourTypeOpen);
                    setIsMonthOpen(false);
                    setIsDirectionOpen(false);
                  }}
                  className="w-full h-[52px] px-4 text-left bg-gray-50 border border-gray-200 rounded-lg font-open-sans text-sm text-gray-700 hover:border-[#1E88E5] transition-colors cursor-pointer flex items-center justify-between"
                >
                  <span>{tourType || 'Выберите тип'}</span>
                  <i className={`ri-arrow-down-s-line text-lg transition-transform ${isTourTypeOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isTourTypeOpen && (
                  <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-20">
                    {tourTypes.map((t) => (
                      <button
                        key={t}
                        type="button"
                        onClick={() => {
                          setTourType(t);
                          setIsTourTypeOpen(false);
                        }}
                        className="w-full px-4 py-2 text-left font-open-sans text-sm text-gray-700 hover:bg-[#1E88E5]/10 hover:text-[#1E88E5] transition-colors cursor-pointer"
                      >
                        {t}
                      </button>
                    ))}
                  </div>
                )}
                <input type="hidden" name="tour_type" value={tourType} />
              </div>

              <div className="flex items-end">
                <button
                  type="submit"
                  className="w-full h-[52px] bg-[#1E88E5] hover:bg-[#0D47A1] text-white font-open-sans font-semibold px-8 rounded-lg text-base transition-colors duration-300 shadow-md whitespace-nowrap cursor-pointer"
                >
                  Найти тур
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
              <div className="md:col-span-3">
                <div className="flex flex-wrap gap-2 mb-3">
                  {allTags.map((tag) => (
                    <button
                      key={tag}
                      type="button"
                      className="h-[36px] px-4 bg-gray-50 hover:bg-[#1E88E5] text-gray-700 hover:text-white border border-gray-200 hover:border-[#1E88E5] rounded-full font-open-sans text-xs transition-all duration-300 cursor-pointer whitespace-nowrap"
                    >
                      {tag}
                    </button>
                  ))}
                </div>
                <button
                  type="button"
                  onClick={() => setShowAllTags(!showAllTags)}
                  className="h-[36px] inline-flex items-center space-x-2 px-5 bg-white hover:bg-gray-50 text-[#5D6D7E] border border-gray-300 rounded-full font-open-sans text-xs transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  <span>{showAllTags ? 'Скрыть теги' : 'Еще теги'}</span>
                  <i className={`ri-arrow-${showAllTags ? 'up' : 'down'}-s-line text-base transition-transform`}></i>
                </button>
              </div>

              <div className="flex items-center justify-end">
                <p className="font-open-sans text-sm text-gray-600 text-right">
                  Запланировано <strong className="font-semibold text-[#1E88E5]">120 туров</strong> в <strong className="font-semibold text-[#1E88E5]">30 странах</strong>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TourSearchForm;
